import { CtrlType } from "@yuigoto/ctrl";

export const BillingAddressChangeControl = [
    {
        name: "BillingPostalCode",
        label: "CEP",
        type: CtrlType.CEP,
        maxLength: 8
    },
   /* {
        name: "uf",
        label: "UF"
    },*/
    {
        name: "BillingCity",
        label: "Cidade"
    },
    {
        name: "BillingNeighborhood",
        label: "Bairro"
    },
    {
        name: "BillingStreet",
        label: "Endereço"
    },
    {
        name: "BillingStreetNumber",
        label: "Número"
    },
    {
        name: "BillingStreetExtensions",
        label: "Complemento"
    },
    {
        name: "shippingName",
        label: "Nome"
    },
    {
        name: "shippingPhone",
        label: "Número"
    }
]